import { Injectable } from "@angular/core";
import { DomainEnums, Month } from "../classes/infrastructure/enums";
import { AppStateManageService } from "./app-state-manage.service";
import { ServerCommunicatorService } from "./server-communicator.service";
import { FinancialYearMonthRequest } from "../classes/infrastructure/request_response/financialyearmonthrequest";
import { UIUtils } from "./uiutils.service";
import { FinancialYearMonthListResponse } from "../classes/infrastructure/request_response/financialyearmonthlistresponse";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";

export class DummyList {
  Ref: number = 0;
  Name: string = '';
  Days: number = 0
}

export class MonthYearResponse {
  CurrentMonth: number = 0;
  PreviousMonth: number = 0;
  MonthList: any[] = [];
  Month: number = 0;
  FinancialYearRef: number = 0;
  previousFinancialYearRef: number = 0;
  CurrentFinancialYearRef: number = 0;
  CurrentFinancialYearName: string = "";
  YearsList: DummyList[] = [];
  IsApril: boolean = false;
  FinancialYearMonthList: FinancialYearMonthListResponse[] = [];
}

@Injectable({
  providedIn: "root",
})


export class MonthYearInitService {
  constructor(
    private appStateManage: AppStateManageService,
    private serverCommunicatorService: ServerCommunicatorService,
    private uiUtils: UIUtils,
  ) { }
  // ---------- SHARED STATE ----------
  currentMonth: number = 0;
  previousMonth: number = 0;
  month: number = 0;

  FinancialYearRef: number = 0;
  PreviousFinancialYearRef: number = 0;
  CurrentFinancialYearRef: number = 0;

  IsPreviousMonthMarch: boolean = false;

  FinancialYearMonthList: FinancialYearMonthListResponse[] = [];

  // ✅ Central state management using BehaviorSubject (reactive)
  public monthYearState$ = new BehaviorSubject<MonthYearResponse>(new MonthYearResponse());

  initialize() {
    let monthList: any[] = [];
    let currentFinancialYear: string | null = null;
    let yearsList: { Ref: number; Name: string }[] = [];
    let isApril = false;

    // ---------- MONTH LOGIC ----------
    const selectedMonths = this.appStateManage.getMonths();
    if (selectedMonths.length > 0) {
      this.currentMonth = selectedMonths[0];
      this.previousMonth = selectedMonths[1];
    }

    monthList = DomainEnums.MonthList(true, "Select Month")
      .filter(
        (m) => m.Ref === this.currentMonth || m.Ref === this.previousMonth,
      )
      .sort((a, b) => {
        if (a.Ref === this.previousMonth) return -1;
        if (b.Ref === this.previousMonth) return 1;
        return 0;
      });

    this.month = this.currentMonth;

    // ---------- FINANCIAL YEAR LOGIC ----------
    const stored = this.appStateManage.StorageKey.getItem(
      "FinancialYearResponses",
    );

    const financialYearResponses = stored ? JSON.parse(stored) : [];

    if (financialYearResponses.length === 1) {
      this.FinancialYearRef = financialYearResponses[0].financial_year_id;

      currentFinancialYear = financialYearResponses[0].short_name || null;
    } else if (financialYearResponses.length > 1) {
      this.FinancialYearRef = financialYearResponses[0].financial_year_id;

      this.PreviousFinancialYearRef =
        financialYearResponses[1].financial_year_id;

      this.CurrentFinancialYearRef = financialYearResponses[0].financial_year_id;

      yearsList = financialYearResponses;
      isApril = true;
    }

    // ---------- RETURN ----------
    return {
      currentMonth: this.currentMonth,
      previousMonth: this.previousMonth,
      monthList,
      month: this.month,
      financialYearRef: this.FinancialYearRef,
      previousFinancialYearRef: this.PreviousFinancialYearRef,
      currentFinancialYearRef: this.CurrentFinancialYearRef,
      currentFinancialYear,
      yearsList,
      isApril,
    };
  }



  async initializeWithTransType(TransactionType: number) {

    const req = new FinancialYearMonthRequest();
    req.LoginToken = this.appStateManage.getLoginToken();
    req.TransactionType = TransactionType;
    let monthRefList: number[] = [];
    let monthList: DummyList[] = [];
    let currentFinancialYearName: string = '';
    let yearsList: DummyList[] = [];
    let isApril = false;

    this.ResetMonthYearState();

    let response = await this.serverCommunicatorService.GetFinancialYearMonthList(req);
    let YearMonthData = response.ObjectTag
    console.log("response month :", response);
    //response.Successful = true;
    if (!response.Successful) {
      this.uiUtils.showErrorMessage("Error", response.Message);
      return;
    }

    // ---------- MONTH LOGIC ----------

    monthRefList = YearMonthData.FinancialYearMonthListResponse.map(e => e.Month);

    // monthList = DomainEnums.MonthList(true, "Select Month")
    //             .filter(e=> monthRefList.includes(e.Ref))

    monthList = YearMonthData.FinancialYearMonthListResponse
      .sort((a, b) => a.DisplayOrder - b.DisplayOrder)
      .map(m => ({
        Ref: m.Month,
        Name: m.MonthName,
        Days: 0
      }))

    this.currentMonth = monthRefList[0];

    // ---------- FINANCIAL YEAR LOGIC ----------
    this.FinancialYearMonthList = YearMonthData.FinancialYearMonthListResponse;

    const uniqueFinancialYears = [
      ... new Map(this.FinancialYearMonthList.map(m => [m.FinancialYearRef, m])).values()
    ]

    yearsList = uniqueFinancialYears
      .sort((a, b) => a.DisplayOrder - b.DisplayOrder)
      .map(m => ({
        Ref: m.FinancialYearRef,
        Name: m.ShortName,
        Days: 0
      }));


    if (yearsList.length === 1) {
      this.FinancialYearRef = yearsList[0].Ref;
      currentFinancialYearName = yearsList[0].Name;
    } else if (yearsList.length > 1) {
      this.FinancialYearRef = yearsList[0].Ref;

      this.PreviousFinancialYearRef =
        yearsList[1].Ref;

      this.CurrentFinancialYearRef = yearsList[0].Ref;
      currentFinancialYearName = yearsList[0].Name;

    }

    var monthYearResponse = new MonthYearResponse();
    monthYearResponse.CurrentMonth = this.currentMonth;
    monthYearResponse.PreviousMonth = this.previousMonth;
    monthYearResponse.MonthList = monthList;
    monthYearResponse.Month = this.month;
    monthYearResponse.FinancialYearRef = this.FinancialYearRef;
    monthYearResponse.previousFinancialYearRef = this.PreviousFinancialYearRef;
    monthYearResponse.CurrentFinancialYearRef = this.CurrentFinancialYearRef;
    monthYearResponse.CurrentFinancialYearName = currentFinancialYearName;
    monthYearResponse.YearsList = yearsList;
    monthYearResponse.IsApril = isApril;
    monthYearResponse.FinancialYearMonthList = this.FinancialYearMonthList;

    // Set BehaviorSubject
    this.monthYearState$.next(monthYearResponse);

    return monthYearResponse;

  }
  // ---------- MONTH CHANGE ----------
  // In MonthYearInitService
  // OnMonthChnages = (selectedMonth: number): number => {
  //   if (selectedMonth === Month.March && this.previousMonth === Month.March) {
  //     this.FinancialYearRef = this.PreviousFinancialYearRef;
  //     this.IsPreviousMonthMarch = true;
  //     this.month = Month.March;
  //   } else if (
  //     selectedMonth === Month.April &&
  //     this.previousMonth === Month.March
  //   ) {
  //     this.FinancialYearRef = this.CurrentFinancialYearRef;
  //     this.IsPreviousMonthMarch = true;
  //     this.month = Month.April;
  //   } else {
  //     this.IsPreviousMonthMarch = false;
  //     this.month = selectedMonth;
  //   }

  // // Return updated month to the component
  //   return this.month;
  // };

  GetFinancialYearRefByMonthChange = (selectedMonth: number): number => {

    let financialYearRef = 0;

    let financialYearMonthList = this.monthYearState$.value.FinancialYearMonthList;

    financialYearRef = financialYearMonthList.find(e => e.Month == selectedMonth)?.FinancialYearRef ?? 0;

    // Return updated month to the component
    return financialYearRef;
  };

  // ---------- YEAR CHANGE ----------
  OnYearChnages = (SelectedYear: number): number => {
    if (
      SelectedYear === this.CurrentFinancialYearRef &&
      this.IsPreviousMonthMarch
    ) {
      // Month needs to reset to currentMonth
      this.month = this.currentMonth;
    } else if (
      SelectedYear === this.PreviousFinancialYearRef &&
      this.IsPreviousMonthMarch
    ) {
      // Month needs to reset to currentMonth
      this.month = Month.March;
    }

    // Return the updated month for component to bind
    return this.month;
  };

  ResetMonthYearState = () => {
    this.monthYearState$.next(new MonthYearResponse());
  }

  GetMonthYearState = () => {
    let monthYearResponse = new MonthYearResponse();

    let currentState = this.monthYearState$.value;

    monthYearResponse.CurrentMonth = currentState.CurrentMonth;
    monthYearResponse.PreviousMonth = currentState.PreviousMonth;
    monthYearResponse.Month = currentState.Month;
    monthYearResponse.MonthList = currentState.MonthList;
    monthYearResponse.FinancialYearRef = currentState.FinancialYearRef;
    monthYearResponse.FinancialYearMonthList = currentState.FinancialYearMonthList;
    monthYearResponse.previousFinancialYearRef = currentState.previousFinancialYearRef;
    monthYearResponse.CurrentFinancialYearRef = currentState.CurrentFinancialYearRef;
    monthYearResponse.CurrentFinancialYearName = currentState.CurrentFinancialYearName;
    monthYearResponse.YearsList = currentState.YearsList;
    monthYearResponse.IsApril = currentState.IsApril;

    return monthYearResponse;

  }
}
